// extracted by mini-css-extract-plugin
export default {"label":"RsvpQuestionText_label__NTBgd","switchWrapper":"RsvpQuestionText_switchWrapper__VtfEm"};